<!-- vertical layout -->
<app-vertical-layout [layoutWidth]="layoutWidth">
</app-vertical-layout>
<ngx-spinner name="global"  bdColor = "rgba(0, 0, 0, 0.9)" size = "medium" color = "#fff" type = "square-jelly-box" [fullScreen] = "true"><p style="color: white" > Ładuje... </p></ngx-spinner>

<!-- "What's new" announcement modal -->
<ng-template #whatsNewModal let-modal>
    <div class="whats-new">
        <button type="button" class="whats-new__close" aria-label="Zamknij" (click)="modal.dismiss()">
            <i class="fi fi-rr-cross-small"></i>
        </button>

        <div class="whats-new__hero">
            <div class="whats-new__badge"><i class="fi fi-rr-rocket"></i> Aktualizacja</div>
            <h3 class="whats-new__title">Co nowego w Fodimi?</h3>
            <p class="whats-new__subtitle">
                Ostatnio sporo się u nas zmieniło — odświeżyliśmy wygląd panelu i dorzuciliśmy narzędzia,
                które ułatwią Ci codzienne prowadzenie restauracji. Oto najważniejsze nowości:
            </p>
        </div>

        <div class="whats-new__body">
            <div class="whats-new__item">
                <div class="whats-new__icon"><i class="fi fi-rr-apps"></i></div>
                <div class="whats-new__text">
                    <h5>Nowe, czytelniejsze menu</h5>
                    <p>Przeprojektowaliśmy menu boczne — jest teraz przejrzystsze i lepiej pogrupowane,
                        więc szybciej dotrzesz do tego, czego potrzebujesz.</p>
                </div>
            </div>

            <div class="whats-new__item">
                <div class="whats-new__icon"><i class="fi fi-rr-edit"></i></div>
                <div class="whats-new__text">
                    <h5>Odświeżona edycja produktu</h5>
                    <p>Szczegóły produktu trafiły do wygodnych zakładek. Zdjęcia, warianty, dodatki i ceny
                        ustawisz teraz prościej, szybciej i bardziej intuicyjnie.</p>
                </div>
            </div>

            <div class="whats-new__item">
                <div class="whats-new__icon"><i class="fi fi-rr-chart-histogram"></i></div>
                <div class="whats-new__text">
                    <h5>Komplet nowych raportów</h5>
                    <p>Pełna kontrola nad lokalem w jednym miejscu: finanse, sprzedaż produktów i kategorii,
                        ruch godzinowy, dostawy i kurierzy, a także analiza klientów oraz pracowników —
                        spójny, czytelny widok z eksportem do XLS.</p>
                </div>
            </div>

            <div class="whats-new__item" *ngIf="hasKiosk">
                <div class="whats-new__icon"><i class="fi fi-rr-dashboard-monitor"></i></div>
                <div class="whats-new__text">
                    <h5>Personalizacja kiosku</h5>
                    <p>Masz kiosk samoobsługowy? Teraz samodzielnie dopasujesz jego wygląd do swojej marki —
                        kolory, grafiki i układ ekranu, na którym zamawiają Twoi goście.</p>
                </div>
            </div>

            <div class="whats-new__item">
                <div class="whats-new__icon"><i class="fi fi-rr-devices"></i></div>
                <div class="whats-new__text">
                    <h5>Drugi ekran POS po Twojemu</h5>
                    <p>Jeśli korzystasz z POS z drugim ekranem dla gości, możesz teraz zmienić jego wygląd —
                        dodać logo i banery oraz dopasować sposób prezentacji zamówienia.</p>
                </div>
            </div>
        </div>

        <div class="whats-new__footer">
            <button type="button" class="btn btn-primary btn-lg whats-new__cta" (click)="modal.close()">
                Świetnie, zaczynam!
            </button>
        </div>
    </div>
</ng-template>
